import React, { Component } from 'react';
import Fade from './Fade.js';
import axios from 'axios';
import Cookies from 'universal-cookie'; 
import {AddWebsiteForm} from './AddWebsiteForm';
import {Loader} from './Loader.js';
import { HorizontalLine } from './HorizontalLine.js';

export class CreateWidget extends React.Component {

    state = {
        website_name: '',
        website_url: '',
        showErrorMsg: false,
        errorMsg: null,
        successMsg: '',
        showSuccessMsg: false,
        isLoading: false
    }

    constructor(props) {
        super(props);
    }

    // Получение токена доступа
    getAccessToken = () => {
        const cookies = new Cookies();
        return cookies.get('clickanti_token');
    }

    msgTimer = 3000

    doShowErrorMsg = (msg) => {
        this.setState({
            errorMsg: msg,
            showErrorMsg: true
        });
        
        setTimeout(() => { 
            this.setState({
                errorMsg: null,
                showErrorMsg: false
            });
        }, this.msgTimer);
    }
    
    doShowSuccessMsg = (msg) => {
        this.setState({
            successMsg: msg,
            showSuccessMsg: true
        });
        
        setTimeout(() => { 
            this.setState({
                successMsg: null,
                showSuccessMsg: false
            });
        }, 2000);
    }

    updateWebsiteName = (e) => {
        this.setState({
            website_name: e.target.value
        });
    }

    updateWebsiteUrl = (e) => {
        this.setState({
            website_url: e.target.value
        });
    }

    doSave = (e) => {
        e.preventDefault();
        
        const token = this.getAccessToken();
        
        if (!token) {
            this.doShowErrorMsg('Необходима авторизация');
            window.location.href = '/auth';
            return;
        }

        // Простая валидация
        if (!this.state.website_name || !this.state.website_url) {
            this.doShowErrorMsg('Заполните все поля');
            return;
        }
        
        this.setState({
            isLoading: true
        });
        
        // Подготавливаем данные для отправки
        const websiteData = {
            name: this.state.website_name,
            url: this.state.website_url
        };
        
        console.log('Sending website data:', websiteData);
        
        axios.post(
            'https://api.clickanti.ru/api/clickanti/websites/create/', 
            websiteData,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }
        )
        .then(res => {
            this.setState({
                isLoading: false
            });
            
            console.log('Website created:', res.data);
            
            // Успешное создание
            this.doShowSuccessMsg('Сайт успешно добавлен!');
            
            // Редирект на список сайтов
            setTimeout(() => {
                window.location.href = '/websites';
            }, 2000);
        })
        .catch(err => {
            console.error('Website creation error:', err);
            this.setState({
                isLoading: false
            });
            
            let errorMessage = 'Произошла ошибка при добавлении сайта';
            
            if (err.response) {
                console.log('Error response:', err.response.data);
                
                // Обработка ошибок валидации от DRF
                if (err.response.data) {
                    if (err.response.data.name) {
                        errorMessage = Array.isArray(err.response.data.name) 
                            ? err.response.data.name[0] 
                            : err.response.data.name;
                    } else if (err.response.data.url) {
                        errorMessage = Array.isArray(err.response.data.url) 
                            ? err.response.data.url[0] 
                            : err.response.data.url;
                    } else if (err.response.data.detail) {
                        errorMessage = err.response.data.detail;
                    } else if (err.response.data.error) {
                        errorMessage = err.response.data.error;
                    } else if (typeof err.response.data === 'string') {
                        errorMessage = err.response.data;
                    }
                }
                
                if (err.response.status === 401) {
                    errorMessage = 'Необходима авторизация';
                    setTimeout(() => {
                        window.location.href = '/auth';
                    }, 2000);
                } else if (err.response.status === 403) {
                    errorMessage = 'Доступ запрещён. Возможно, тариф закончился';
                } else if (err.response.status === 400) {
                    errorMessage = errorMessage || 'Неверные данные. Проверьте все поля';
                } else if (err.response.status === 500) {
                    errorMessage = 'Ошибка сервера. Попробуйте позже';
                }
            } else if (err.request) {
                errorMessage = 'Нет связи с сервером. Проверьте интернет';
            } else {
                errorMessage = err.message || 'Неизвестная ошибка';
            }
            
            this.doShowErrorMsg(errorMessage);
        });
    }
    
    render() {
        return (
            <div className="create-widget-responsive">
                <div>
                    <Fade show={this.state.showErrorMsg}>
                        <div className='errorMessage'>
                            Ошибка: {this.state.errorMsg}
                        </div>
                    </Fade>
                    <Fade show={this.state.showSuccessMsg}>
                        <div className='successMessage'>
                            {this.state.successMsg}
                        </div>
                    </Fade>
                    <Loader loader={this.state.isLoading} />
                    
                    <div className='createPage'>
                        <div className="createPageTitle">
                            <h1 style={{marginBottom:"2px"}}>
                                {this.props.title ? this.props.title : "Добавление сайта"}
                            </h1>
                            <HorizontalLine />
                        </div>
                       
                        <div className='createWidgetMainBlock'>
                            <AddWebsiteForm
                                website_name={this.state.website_name}
                                website_url={this.state.website_url}
                                updateWebsiteName={this.updateWebsiteName}
                                updateWebsiteUrl={this.updateWebsiteUrl}
                                doSave={this.doSave}
                                isLoading={this.state.isLoading}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}